<form class="form-container" [formGroup]="form">
    @if (f['userId'].value != "") {
    <h2 mat-dialog-title>{{'UPDATE_USER' | translate}}</h2>
    } @else {
    <h2 mat-dialog-title>{{'REGISTER_USER' | translate}}</h2>
    }
    <mat-dialog-content class="mat-typography">
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'USER_NAME_LABEL' | translate}} </mat-label>
                    <input matInput type="text" placeholder="User Name" formControlName="userName">
                    @if (f['userName'].errors) {
                    <mat-error>
                        @if (f['userName'].errors['pattern']) { <span>{{'INVALID_USERNAME_PATTERN' | translate}}</span>}
                        @if (f['userName'].errors['required']) { <span>{{'USER_NAME_REQUIRED' | translate}}</span>}
                        @if (f['userName'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
                        @if (f['userName'].errors['minlength']) { <span>{{'MINLENGTH_5' | translate}}</span>}
                        @if (f['userName'].errors['usernameStart']) { <span>{{'USERNAME_START' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'FULL_NAME' | translate}} </mat-label>
                    <input matInput type="text" placeholder="Full Name" formControlName="name">
                    @if (f['name'].errors) {
                    <mat-error>
                        @if (f['name'].errors['required']) { <span>{{'FULL_NAME_REQUIRED' | translate}}</span>}
                        @if (f['name'].errors['maxlength']) { <span>{{'MAX_LENGTH_100' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'GENDER' | translate}}</mat-label>
                    <mat-select formControlName="gender">
                        <mat-option [value]="'Male'">Male</mat-option>
                        <mat-option [value]="'Female'">Female</mat-option>
                        <mat-option [value]="'Transgender Person'">Transgender Person</mat-option>
                    </mat-select>
                    @if (f['gender'].errors) {
                    <mat-error>
                        @if (f['gender'].errors['required']) { <span>{{'GENDER_REQUIRED' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'Email' | translate}} </mat-label>
                    <input matInput type="email" placeholder="email" formControlName="email">
                    @if (f['email'].errors) {
                    <mat-error>
                        @if (f['email'].errors['required']) { <span>{{'EMAIL_REQUIRED' | translate}}</span>}
                        @if (f['email'].errors['maxlength']) { <span>{{'MAX_LENGTH_60' | translate}}</span>}
                        @if (f['email'].errors['email']) { <span>{{'INVALID_EMAIL' | translate}}</span>}
                        @if (f['email'].errors['pattern']) { <span>{{'INVALID_EMAIL' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12" style="margin-bottom: 25px;">
                <!-- <ngx-intl-tel-input
                    [preferredCountries]="preferredCountries"
                    [enableAutoCountrySelect]="true"
                    [enablePlaceholder]="true"
                    customPlaceholder="Phone"
                    [searchCountryFlag]="true"
                    [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                    [selectFirstCountry]="true"
                    [selectedCountryISO]="CountryISO.Pakistan"
                    [maxLength]="20"
                    [phoneValidation]="true"
                    [separateDialCode]="separateDialCode"
                    [numberFormat]="PhoneNumberFormat.National"
                    formControlName="mobile"
                    class="custom-control custom-phone-input"
                >
                </ngx-intl-tel-input>
                @if (f['mobile'].touched && f['mobile'].errors) {
                    <div class="text-danger">
                        @if (f['mobile'].errors['required']) { <span>{{'MOBILE_REQUIRED' | translate}}</span>}
                        @if (f['mobile'].errors['pattern']) { <span>{{'INVALID_MOBILE_PATTERN' | translate}}</span>}
                        @if (f['mobile'].errors['maxlength']) { <span>{{'MAX_LENGTH_20' | translate}}</span>}
                        @if (f['mobile'].errors['minlength']) { <span>{{'MINLENGTH_11' | translate}}</span>}
                    </div>
                } -->
                <mat-form-field appearance="outline">
                    <mat-label>{{'PHONE' | translate}} </mat-label>
                    <input matInput type="text" placeholder="mobile" formControlName="mobile">
                    @if (f['mobile'].errors) {
                    <mat-error>
                        @if (f['mobile'].errors['required']) { <span>{{'MOBILE_REQUIRED' | translate}}</span>}
                        @if (f['mobile'].errors['pattern']) { <span>{{'INVALID_MOBILE_PATTERN' | translate}}</span>}
                        @if (f['mobile'].errors['maxlength']) { <span>{{'MAX_LENGTH_20' | translate}}</span>}
                        @if (f['mobile'].errors['minlength']) { <span>{{'MINLENGTH_11' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'SEGMENT_TYPE' | translate}} </mat-label>
                    <mat-select formControlName="segmentId">
                        @for (i of segments;track i) {
                        <mat-option [value]="i.segmentId">{{i.name}}</mat-option>
                        }
                    </mat-select>
                    @if (f['segmentId'].errors) {
                    <mat-error>
                        @if (f['segmentId'].errors['required']) { <span>{{'SEGMENT_REQUIRED' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'ROLE' | translate}} </mat-label>
                    <mat-select formControlName="role">
                        @for (role of roleEnum;track role) {
                        <mat-option [value]="role">{{role | rolePipe}}</mat-option>
                        }
                    </mat-select>
                    @if (f['role'].errors) {
                    <mat-error>
                        @if (f['role'].errors['required']) { <span>{{'ROLE_REQUIRED' | translate}}</span>}
                    </mat-error>
                    }

                </mat-form-field>
            </div>
            @if (f['userId'].value == "") {
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'PASSWORD' | translate}} </mat-label>
                    <input matInput type="password" placeholder="Password" formControlName="password">
                    @if (f['password'].errors) {
                    <mat-error>
                        @if (f['password'].errors['required']) { <span>{{'PASSWORD_REQUIRED' | translate}}</span>}
                        @if (f['password'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                        @if (f['password'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                        @if (f['password'].errors['minLength']) { <span>{{'MINLENGTH_8' | translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{'CONFIRM_PASSWORD' | translate}} </mat-label>
                    <input matInput type="password" placeholder="Password" formControlName="confirmPassword">
                    @if (f['confirmPassword'].errors) {
                    <mat-error>
                        @if (f['confirmPassword'].errors['required']) { <span>{{'PASSWORD_REQUIRED' |
                            translate}}</span>}
                        @if (f['confirmPassword'].errors['maxlength']) { <span>{{'MAX_LENGTH_30' | translate}}</span>}
                        @if (f['confirmPassword'].errors['pattern']) { <span>{{'PASSWORD_PATTERN' | translate}}</span>}
                        @if (f['confirmPassword'].errors['mixlength']) { <span>{{'MINLENGTH_8' | translate}}</span>}
                        @if (f['confirmPassword'].errors['MatchPassword']) { <span>{{'MATCH_PASSWORD' |
                            translate}}</span>}
                    </mat-error>
                    }
                </mat-form-field>
            </div>
            }
            <div class="row">
                <div class="col-12">
                    <mat-checkbox formControlName="canSeeInfo" color="primary">{{'VIEW_CITIZEN_INFO' |
                        translate}}</mat-checkbox>
                </div>
                            @if (f['userId'].value != "") {
                <div class="col-12">
                    <mat-checkbox formControlName="isActive" color="primary">{{'Active' | translate}}</mat-checkbox>
                </div>
                }
                <div class="col-12">
                    <mat-checkbox formControlName="canViewAnonymousInfo" color="primary">{{'VIEW_ANONYMOUS_INFO' |
                        translate}}</mat-checkbox>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (f['userId'].value != "") {
        <button mat-button class="btn-primary" (click)="edit()" color="primary" cdkFocusInitial>{{'Save' |
            translate}} </button>
        } @else {
        <button mat-button class="btn-primary" (click)="add()" color="primary" cdkFocusInitial>{{'Add_BUTTON'
            | translate}} </button>
        }
        <button mat-button class="btn-secondary" mat-dialog-close>{{'Cancel' | translate}}</button>
    </mat-dialog-actions>
</form>